import { ColDef, ValueGetterParams } from '@ag-grid-community/core';
import { DATE_TIME_FORMAT, getLocalDate } from '../../../utils/date.utils';

const prefix = 'DATA_GRID.';
export const prepareAdditionalDataColumns = (): ColDef[] => [
  {
    field: 'importAuthor',
    headerName: prefix + 'IMPORT_AUTHOR'
  },
  {
    field: 'importFilename',
    headerName: prefix + 'IMPORT_FILE_NAME'
  },
  {
    field: 'importDate',
    headerName: prefix + 'IMPORT_DATE',
    valueGetter: (value: ValueGetterParams) => getLocalDate(value.data.importDate, DATE_TIME_FORMAT)
  },
  {
    field: 'usedInOrder',
    headerName: prefix + 'ORDERS'
  },
];

